<template>
  <v-layout class="ma-0 pa-0 change-over-period" column :class="data.class">
    <v-layout class="p0 metric-change-top" align-center justify-center>
      <v-icon v-if="changeIndicator">
        {{ data.changeIcon }}
      </v-icon>
      <div class="metric-change-value">{{ number ? number + append : '' }}</div>
    </v-layout>
    <div class="metric-change-label">
      {{ label }}
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'MetricNumber',
  props: {
    changeIndicator: {
      type: Boolean,
      default: false
    },
    number: {
      type: [String, Number]
    },
    label: {
      type: String
    },
    append: {
      type: String,
      default: ''
    }
  },
  computed: {
    data: function() {
      const data = {}
      if (+this.number < 0) {
        data.changeIcon = 'call_received'
        data.class = 'score-down'
      } else if (+this.number > 0) {
        data.changeIcon = 'call_made'
        data.class = 'score-up'
      } else {
        data.changeIcon = 'remove'
        data.class = 'score-neutral'
      }
      return data
    }
  }
}
</script>

<style lang="stylus">
.change-over-period {
    height 70px
    margin-bottom 35px

    .v-icon {
        font-size 26px
    }

    &.score-down {

        .v-icon {
            color $color-error
        }
    }

    &.score-up {
        .v-icon {
            color $color-accent
        }

    }

    .metric-change-value {
        font-size 30px
        color $color-primary
        margin-left 5px
    }

    .metric-change-label {
        color $color-primary-light-5
        font-size 16px
        text-align center
    }
}
</style>
